module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.id,
      "num_files": _vm.num_documents()
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.files) ? _c('div', [_vm._l((_vm.documents), function(v) {
    return _c('div', [_c('p', [_vm._v("\n                File: "), _c('a', {
      attrs: {
        "href": v.file,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(v.name))]), _vm._v("  \n                "), (!_vm.readonly) ? _c('span', [_c('a', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "Remove file",
        "filename": v.name
      },
      on: {
        "click": function($event) {
          return _vm.delete_document(v)
        }
      }
    })]) : _vm._e()])])
  }), _vm._v(" "), (_vm.show_spinner) ? _c('div', [_c('i', {
    staticClass: "fa fa-2x fa-spinner fa-spin"
  })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.repeat), function(n) {
    return (!_vm.readonly) ? _c('div', [(_vm.isRepeatable || (!_vm.isRepeatable && _vm.num_documents() == 0)) ? _c('div', [_c('input', {
      attrs: {
        "name": _vm.name,
        "type": "file",
        "data-que": n,
        "accept": _vm.fileTypes
      },
      on: {
        "change": _vm.handleChangeWrapper
      }
    })]) : _vm._e()]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-106f3b0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/compliance_file.vue
// module id = 922
// module chunks = 0